import styled from "styled-components";
import { defaultBreakpoints } from "styled-media-query";

export const PostWrapper = styled.div`
  border-radius: 12px;
  font-family:  ${({ theme }) => theme.default.fontFamily.secondaryFont};
  background-color: white;
  padding: 1rem;
  p, img {
    margin: 20px 0 0;  
  }
  @media (max-width: ${defaultBreakpoints.medium}) {
    width: 100%;
  }
`;

export const AuthorWrapper = styled.div`
  display: flex;
  span {
    color: ${({ theme }) => theme.default.color.primary};
  }
  p {
    margin: 0;  
  }  
  .date_wrapper {
    display: flex;
    align-items: center;
  }
`;
